export {
  Collapse,
  CollapseItem,
  CollapseHeading,
  CollapseButton,
  CollapsePanel,
} from "./styles"
